import AWSCloudwatch from 'aws-sdk/clients/cloudwatchlogs';

const env = process.env.NODE_ENV;
const envLogStream =
  process.env.REACT_APP_AWS_LOG_STREAM || 'dev_client_errors_stream';

const credentials = {

  accessKeyId: process.env.REACT_APP_AWS_LOG_KEY_ID || null,
  secretAccessKey: process.env.REACT_APP_AWS_LOG_KEY_SECRET || null,
};

const cloudwatchlogs = new AWSCloudwatch({ region: 'us-west-2', credentials });

const logGroupName = 'client_errors';
const logStreamName = envLogStream;
let nextToken = '';

const describeParams = {
  logGroupName,
};

const putParams = {
  logEvents: [],
  logGroupName,
  logStreamName,
  sequenceToken: nextToken,
};

const _fetchNextToken = () => {
  return new Promise((resolve, reject) => {
    cloudwatchlogs.describeLogStreams(describeParams, (err, data) => {
      if (err) {
        reject(err);
      }
      if (data) {
        resolve(data);
      }
    });
  });
};

const _putCloudLogs = () => {
  return new Promise((resolve, reject) => {
    cloudwatchlogs.putLogEvents(putParams, (err, data) => {
      if (err) {
        reject(err);
      }
      if (data) {
        resolve(data);
      }
    });
  });
};

const _sendCloudWatchEvents = () => {
  const logsToSend = putParams.logEvents.length;
  const logStream = envLogStream;

  _fetchNextToken()
    .then(response =>
      response.logStreams.filter(stream => stream.logStreamName == logStream)
    )
    .then(
      logStream => (putParams.sequenceToken = logStream[0].uploadSequenceToken)
    )
    .catch(err => console.error('error getting upload sequence token', err))
    .then(() => _putCloudLogs())
    .catch(err => console.error('Error writing logs to CloudWatchLogs: ', err))
    .then(
      () =>
        (putParams.logEvents = putParams.logEvents.slice(
          logsToSend,
          putParams.logEvents.length
        ))
    );
};

const logErrorForCloudWatch = errorObject => {
  if (env != 'development') {
    const {
      type,
      message,
      source,
      error,
      currentUser,
      currentCompany,
      onMobile,
      httpError,
      spaVersion,
    } = errorObject;

    let location;
    if(window.location && window.location.href) {
      location = window.location.href;
    } else {
      location = 'unavailable';
    }

    let userAgentString;
    if(window.navigator && window.navigator.userAgent) {
      userAgentString = window.navigator.userAgent;
    } else {
      userAgentString = 'unavailable';
    }

    if (currentUser && currentUser.token) {
      delete currentUser.token;
    }

    let mobile;
    if (onMobile && window.cordova) {
      mobile = {
        onMobile: true,
        appVer: window.cordova.appVersion ? window.cordova.appVersion : 'unavailable',
        buildNo: window.cordova.buildNumber ? window.cordova.buildNumber : 'unavailable',
        environment: window.cordova.environment ? window.cordova.environment : 'unavailable',
      };
    } else {
      mobile = '';
    }

    let errorSource;
    if (source) {
      if (source.includes('file://') && window.cordova.environment) {
        errorSource = window.cordova.environment;
      } else {
        errorSource = source;
      }
    } else if (window.location.origin) {
      errorSource = window.location.origin;
    } else {
      errorSource = '';
    }

    const errorPayload = JSON.stringify({
      type: type || '',
      source: errorSource,
      spaVersion,
      message: message || error.message || 'No Message available',
      mobile,
      user: {
        currentUser: currentUser || 'unavailable',
        currentCompany: currentCompany && currentCompany.name ? currentCompany.name : 'unavailable',
      },
      apiError: httpError || '',
      location: location || 'URL unavailable',
      userAgentString: userAgentString || 'Broswer info unavailable',
    });

    const AWSErrorObject = {
      timestamp: Date.now(),
      message: errorPayload,
    };

    putParams.logEvents.push(AWSErrorObject);
    _sendCloudWatchEvents();
  }
};

export default logErrorForCloudWatch;



// WEBPACK FOOTER //
// ./src/helpers/awsCloudwatchLogs.js